import { render, staticRenderFns } from "./ConfirmacionVincularPersonalConvocatoria.vue?vue&type=template&id=cb5d07da"
import script from "./ConfirmacionVincularPersonalConvocatoria.vue?vue&type=script&lang=js"
export * from "./ConfirmacionVincularPersonalConvocatoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports